// extracted by mini-css-extract-plugin
export default {"filter-column-height":"invoicesFilterBox_filter-column-height__majJj"};